import axios from 'axios'
import utils from './utils'
import convert from 'xml-js'

const apiBrightsign = {
  async getTokens(auth) {
    const username = `${auth.network}/${auth.username}`
    const access_token = await new Promise((resolve, reject) => axios.post(`https://api.${auth.domain}.com/2017/01/REST/token`,
      `grant_type=password&username=${username}&password=${auth.password}`
    )
    .then(function(response) {
      resolve(response.data.access_token)
    })
    .catch(err => {
      reject(err)
    }))
    return access_token
  },
  async getDevice(auth, access_token, nextMarker) {
    const devices = await new Promise((resolve, reject) => axios.get(`https://api.dviewnetwork.com/2017/01/REST/devices/?marker=${nextMarker}&pageSize=100`, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      const resultDevices = []
      let result = convert.xml2json(response.data, {compact: true, spaces: 4});
      result= JSON.parse(result)
      let devices = result.PagedDeviceList.Items['d2p1:Device']
      if (devices && !Array.isArray(devices)) {
        devices = []
        devices.push(result.PagedDeviceList.Items['d2p1:Device'])
        // console.log('aaaa', devices)
      }
      if (!devices || !Array.isArray(devices)) resolve(null)
      const nextMarker = result.PagedDeviceList.NextMarker._text
      for (const d of devices) {
        // console.log(d)
        const id = d['d2p1:Id']._text
        const name = d['d2p1:Name']._text
        const status = d['d2p1:HealthStatus']._text
        const letime = d['d2p1:LastErrorTime']._text

        const groupPure = d['d2p1:TargetGroup']
        const group = {
          id: groupPure['d2p1:Id']._text,
          name: groupPure['d2p1:Name']._text
        }
        resultDevices.push({
          network: auth.network,
          id,
          name,
          status,
          group,
          letime
        })
      }
      resolve({ devices: resultDevices, nextMarker: nextMarker })
    })
    .catch(function (err) {
      reject(err)
    }))

    return devices
  },
}

export default apiBrightsign
